// Site link declaration
export enum SITELINKS {
  SIGNIN = "/sign-in",
  VERIFY_SIGNIN = "/verify-sign-in",
  FORGOT_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",
  BROADCAST = "/broadcast",
  BROADCAST_HISTORY = "/broadcast-history",
  DASHBOARD = "/dashboard",
  REQUEST = "/request",
  RESPONSES = "/responses",
  SUBSCRIPTIONS = "/subscriptions",
  TRANSACTIONS = "/transactions",
  USERS = "/users",
  CREATE_USER = "/user/create",
  UPDATE_USER = "/user/update/",
  USER_PROFILE = "/user/",
  ELITE_USER = "/elite-user/",
  ACCOUNT = "/account",
  CHANGE_PASSWORD = "/account/password",
  SETTINGS = "/settings",
  AUDIT_LOG = "/audit-log",
}